import {useState} from 'react';

export default function useChallengeMobileCtaSticky(): boolean {
  const [isSticky] = useState(() => {
    const sticky = getComputedStyle(document.documentElement).getPropertyValue(
      '--xps-challenge-mobile-cta-sticky'
    );

    return sticky.trim() !== 'false';
  });

  return isSticky;
}
